import { render } from "./LoginModelNew.vue?vue&type=template&id=3db23d9a&scoped=true"
import script from "./LoginModelNew.vue?vue&type=script&lang=js"
export * from "./LoginModelNew.vue?vue&type=script&lang=js"

import "./LoginModelNew.vue?vue&type=style&index=0&id=3db23d9a&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2430658573/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3db23d9a"]])

export default __exports__